import variables from '@/scss/utils/_exportVars.scss';

export const breakpoints = Object.keys(variables).reduce((accumulator, key) => {
  return {
    ...accumulator,
    [key]: +variables[key],
  };
}, {});
